import ConfigurableTransition from './_configurable-transition.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableCursor from './_configurable-cursor.js'

export default {
  name: 'Image',
  values: {
    src: undefined,
    fallbackSrc: undefined,
    title: undefined,
    style: {
      aspectRatio: undefined,
      flexGrow: 0,
      fill: undefined,
      stroke: undefined,
      transition: {
        $mixin: [
          {
            configSet: ConfigurableTransition,
          },
        ],
      },
      visibility: 'visible',
      filter: undefined,
      opacity: undefined,
      objectFit: 'contain',
      objectPosition: 'center',
      $mixin: [
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurablePadding,
        },
        {
          configSet: ConfigurableCursor,
        },
      ],
    },
    svgSpritemap: {
      path: undefined,
      idPrefix: undefined,
    },
  },
  meta: {
    extendable: false,
  },
}
